import {Stack, Typography, useTheme} from '@mui/material';
import {GenderEnum} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React from 'react';

const {wellcome, subtitle} = translations['pt-br'].privateFlow.myHospitalization.home;

export const HeaderHomeHospitalization = () => {
	const {colors} = useTheme();
	const {isTablet} = useMediaQueries();
	const {
		firstNameBeneficiary,
		beneficiary: {flSexoUsuarioC},
	} = useAccountInformation();
	const isWoman = [GenderEnum.FEMALE, GenderEnum.WOMAN].includes(flSexoUsuarioC);

	return (
		<Stack>
			<Typography variant={isTablet ? 'h6' : 'h5'}>
				{wellcome
					.replace('o', isWoman ? 'a' : 'o')
					.replace('::beneficiaryName', firstNameBeneficiary)}
			</Typography>
			<Typography variant="body1" color={colors.light.text.primary}>
				{subtitle}
			</Typography>
		</Stack>
	);
};
